import { light } from '@upstox/upstox-ui';
import { INotification } from 'modules/NotificationCenter/typings';
import { ReleaseNotes, ReleaseNotesItem } from 'modules/ReleaseNotes/typings';

export const LAYOUT_KEYS_SYNC = [] as const;
light.colors.background.upstoxLogo = '#ffffff';

export const DEFAULT_THEME: ThemeKeys = 'auto';

export const COMPLIANCE_MODAL_CONFIG: Omit<
  INotification,
  'startDate' | 'endDate'
> = {
  id: 'login-notification',
  classification: 0,
  title: 'Risk Disclosures on derivatives by SEBI',
  message:
    '<ul><li>9 out of 10 individual traders in the equity Futures and Options Segment, incurred net losses.</li><li>On an average, loss makers registered net trading losses close to ₹50,000.</li><li>Over and above the net trading losses incurred, loss makers expended an additional 28% of net trading losses as transaction costs.</li><li>Those making net trading profits, incurred between 15% to 50% of such profits as transaction costs.</li></ul>',
  theme: 'none',
  image: '',
  dismissable: true,
  actions: {
    primary: {
      text: 'Okay, I Understand',
      icon: false,
      action: 'close',
      link: '',
      autoLogin: false,
    },
  },
  variant: 'modal',
};

// WhatsNew Indicator type for Remote Config
export type WhatsNewIndicatorConfig = {
  type: 'INTIMATION_MODAL' | 'NEW_RELEASE_NOTES' | '';
  maxCount: number;
  version: number;
};

// WhatsNew Indicator State for Local Storage
export type WhatsNewIndicatorStatus = {
  type: 'INTIMATION_MODAL' | 'NEW_RELEASE_NOTES' | '';
  count: number;
  version: number;
  expiry: string;
};

export const DEFAULT_REMOTE_CONFIG = {
  sebi_compliance_modal: COMPLIANCE_MODAL_CONFIG,
  chart_content_size_limit_in_kb: 800,
  releaseNotes: {
    whatsNewIndicatorConfig: {
      type: '',
      version: 0,
      maxCount: 0,
    } as WhatsNewIndicatorConfig,
    communityUrl: 'https://community.upstox.com/c/upstox-x-tradingview/24',
    items: [] as ReleaseNotesItem[],
  } as ReleaseNotes,
};

export enum ReleaseNotesIndicatorStates {
  NEW_INTIMATION = 'newIntimation',
  INTIMATION = 'intimation',
  NEW_RELEASE_NOTES = 'newReleaseNotes',
  RELEASE_NOTES = 'releaseNotes',
}
